
import { auth, googleProvider } from '../firebaseConfig';

import { signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, sendEmailVerification, sendPasswordResetEmail, fetchSignInMethodsForEmail } from "firebase/auth";

import { createSignUpUserAccount, isUserAccountDeleted, wasUserAccountCreatedDuringSignUp, doesUserWithEmailAlreadyExist, doesUserWithEmailAndPasswordLoginExist } from "./FunctionCalls";

/*
    Note: If you wanted to check what authentication (provider) the user used to authenrticate/signup you can use code like this:

    const providerId = user.providerData[0]?.providerId;

    if (providerId === "password") {
      console.log("Signed in with email/password");
    } else if (providerId === "google.com") {
      console.log("Signed in with Google");
    } else {
      console.log("Other provider:", providerId);
    }
      
*/

export const signInWithGoogle = async (marketingOptInChecked = false,marketingOptInAgreementLabel=null) => {
  try {

    const signUpResult = {"status":"","message":"","user":null};

    // Note: The logic for signUpWithEmail is totally different

    const result = await signInWithPopup(auth, googleProvider);
    
    const user = result.user;
    
    signUpResult.user = user;

    const userWithEmailPasswordLoginExits = await doesUserWithEmailAndPasswordLoginExist(user.email, auth); //To prevent users from signup by google email when they already have a email/password account with the same emmail
                                                                                                            // We let them to that a member should change themselves into a admin.
                                                                                                            // This check doesn't prevent from addling a google provider to the user, but it won't let them login with the google provider only the email provider

    if (!userWithEmailPasswordLoginExits)
    {
        const accountExists = await doesUserWithEmailAlreadyExist(user.email); 

        if (accountExists === false) // It is sign up
        {

          const userSystemInfo = await getUserSystemInfo();

          if (userSystemInfo != null && userSystemInfo.hasOwnProperty("country") && userSystemInfo.country === "US") //Default values since we don't ask the question in the US
          {
              marketingOptInChecked = true;
              marketingOptInAgreementLabel="N/A";

          }

          await createSignUpUserAccount(user.displayName,user.email,userSystemInfo,marketingOptInChecked,marketingOptInAgreementLabel, auth);

          signUpResult.status = "success"

        } else  //It is sign in 
        {
          const isUserDeleted = await isUserAccountDeleted(user.email,auth);

          if (isUserDeleted === true) //This can only happenn if the original admin is deleted and they had signup with their Google Account
          {
              await signOut(auth);

              signUpResult.user = null;

              signUpResult.status = "account-is-deleted"
              return signUpResult;
          }
        }
      } else 
      {
              await signOut(auth);
              
              signUpResult.status = "already-has-password-login"
              return signUpResult;
      }

      signUpResult.status = "success"

    return signUpResult;

  } catch (error) {
    console.error(error);
  }
};


export const signUpWithEmail = async (email, password, name, marketingOptInChecked = false,marketingOptInAgreementLabel = null) => {

  const signUpResult = {"status":"","message":"","user":null};
  try {
    const accountExists = await doesUserWithEmailAlreadyExist(email);

    if (accountExists === false)
    {

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await sendEmailVerification(user);
      console.log("Verification email sent.");

      signUpResult.user = user;
      signUpResult.status = "verification-email-sent";

      const userSystemInfo = await getUserSystemInfo();

      if (userSystemInfo != null && userSystemInfo.hasOwnProperty("country") && userSystemInfo.country === "US") //Default values since we don't ask the question in the US
      {
          marketingOptInChecked = true;
          marketingOptInAgreementLabel="N/A";

      }

      await createSignUpUserAccount(name, email, userSystemInfo, marketingOptInChecked, marketingOptInAgreementLabel, auth);
      
    } else
    {
      signUpResult.status = "account-already-exists";
 
    }

  } catch (error) {
    if (error != null && error.message != null && error.message.includes("already-in-use"))
      {
        signUpResult.status = "account-already-exists";
      } else
      {
        signUpResult.status = "error";
        signUpResult.message = error.message;  
      }

  }

  return signUpResult;
};


export const resendVerifedEmail = async (email, password) => {
  
  let result = false;
  try {

    let user;

    if (email && password) 
    {
      
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      user = userCredential.user;

    } else {
      user = auth.currentUser;
      await user.reload();
    }

    if (!user) {
      throw new Error("No user is currently signed in.");
    }

    if (!user.emailVerified) {
        
      await sendEmailVerification(user) // Sends verification email

      console.log("Verification email sent.");

      result = false;

    } else
    {
      result = true;
    }


  } catch (error) {
    console.error(error);
    result = false;
  }

  return result;
};

export const hasUserVerifedEmail = async (email, password) => {
 
  let result = false;
  try {
    let user;

    if (email && password) 
    {
      
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      user = userCredential.user;

    } else {
      user = auth.currentUser;
      await user.reload();
    }

    if (!user) {
      throw new Error("No user is currently signed in.");
    }

    if (!user.emailVerified) {
      result = false;
    } else {
      result = true;
    }

  } catch (error) {
    console.error(error);
    result = false;
  }

  return result;
};


export const signInWithEmail = async (email, password) => {

  const signinResult = {"emailSignInstatus":""};

  try {

    const userCredential = await signInWithEmailAndPassword(auth, email, password);

    signinResult.user = userCredential.user;

    if (!userCredential.user.emailVerified) {
      console.log("Please verify your email before logging in.");
     // await signOut(auth); //Sign user out in case they navigate manually to /app
      
     const userWasCreatedDuringSignUp = await wasUserAccountCreatedDuringSignUp(email,auth);

     if (userWasCreatedDuringSignUp) 
      {
         signinResult.emailSignInstatus = "email-not-yet-verified";
      } else
      {
       signinResult.emailSignInstatus = "user-must-change-password";  //This are users created by an admin in the applications /useraccounts screen
      }

     // You might want to log the user out here
    } else {
      //console.log("Welcome, user!");
      signinResult.emailSignInstatus = "successfully-signed-in";
    }
    
    const accountExists = await doesUserWithEmailAlreadyExist(email);
    const isUserDeleted = await isUserAccountDeleted(email, auth);

    if (accountExists === false || isUserDeleted === true)
      {
          await signOut(auth);
          signinResult.emailSignInstatus = "invalid-email-password";
      }
  
  } catch (error) {
    console.error(error);
    signinResult.emailSignInstatus = "invalid-email-password";
  }
  
  return signinResult;
};


export const logout = async () => {
  try {

    auth.currentUser = null;  // Force Firebase to forget the user
    await signOut(auth);

  } catch (error) {
    console.error(error);
  }
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    console.log("Password reset email sent.");
    return { status: "success" };
  } catch (error) {
    console.error("Error sending password reset email:", error);
    return { status: "error", message: error.message };
  }
};


export const getCurrentUser = () => {
  return new Promise((resolve) => {
    onAuthStateChanged(auth, (user) => {
      resolve(user);
    });
  });
};

export const getUserSystemInfo = async () => {
  
  /*
      country: navigator.language.split('-')[1] || "Unknown",
      This only gives you the browswer language, not the user location
  */

  const geoData = await getGeoData();

  return {
    browserType: navigator.userAgent,
    isMobile: navigator.userAgentData ? navigator.userAgentData.mobile : /Mobi|Android/i.test(navigator.userAgent),
    country: geoData.country,
    ipAddress: geoData.ipAddress,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    languagePreferences: navigator.languages || [navigator.language]
  };
};

 export const getGeoData = async () => {

    /*
      Note (for production)
      All services used are public and commonly used in production.

      
      *** For ipinfo.io, consider getting a free token at https://ipinfo.io/signup and replace "demo" with your token for reliability. 
        IPinfo Lite: Our most accurate IP data with unlimited API requests, free for commercial and product use. No monthly fees or credit card required.

    */

    let country = "";
    let ipAddress = "";

    try {
      // Primary: ipapi.co
      const res1 = await fetch("https://ipapi.co/json/");
      if (res1.ok) {
        const data = await res1.json();
        country = normalizeCountryCode(data.country);
        ipAddress =  data.ip;

        console.log("Got Geo Location from ipapi.co");
        return {country:country,ipAddress:ipAddress}
      }

      // Fallback 1: ipinfo.io
      const res2 = await fetch("https://ipinfo.io/json?token=20ae7e13eb69c9"); // You can request a free token for production use
      if (res2.ok) {
        const data = await res2.json();
        country = normalizeCountryCode(data.country);
        ipAddress = data.ip;

        console.log("Got Geo Location from ipinfo.io");
        return {country:country,ipAddress:ipAddress}
      }

      // Fallback 2: geoplugin.net
      const res3 = await fetch("https://www.geoplugin.net/json.gp");
      if (res3.ok) {
        const data = await res3.json();
        console.log("IP Address:", data.geoplugin_request);
        country = normalizeCountryCode(data.geoplugin_countryCode);
        ipAddress = data.geoplugin_request;

        console.log("Got Geo Location from geoplugin.net");
        return {country:country,ipAddress:ipAddress}
      }

      // If all fail
      country = "Unknown";
      ipAddress = "Unknown";

    } catch (error) {
      console.error("Geo detection failed:", error);
      country = "Unknown";
      ipAddress = "Unknown";
    }

    return {country:country,ipAddress:ipAddress}
  };

    // Helper to normalize country codes to 2-letter
  const normalizeCountryCode = (code) => {
    if (!code) return "Unknown";
    const upper = code.toUpperCase();
    const map = {
      "UNITED STATES": "US",
      "USA": "US",
      "U.S.": "US",
      "U.S.A.": "US"
    };
    return map[upper] || upper.slice(0, 2);
  };